import API from "./commons/Api.js";
import { eventBus, EVENTS } from './commons/EventBus.js';
import router from "./commons/Router.js";
import "./libs/dropzone.min.js";
import getCoficeFiscale from './libs/calcoloCF/validazioneCodice.js';
import Utils from "./commons/utils.js";

let dropzone;
let dropzone1;
let dropzoneVideo;
let formData = new FormData();
var currentFile = null;
let autocomplete;
let autocomplete1;
let address;
let addressBar;
let renderedData;
let objectFile = {
  image:null,
  video:null
};
let perc = {
  image:0,
  video:0,
  tot:0
};

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  const template = data.template;
  if (template != 'form_summerfestival2023' || data.refresh) {
    return;
  }
  const baseUrl = location.pathname.split('/')[1];
  if(location.pathname.split('/').length > 2){
    window.history.pushState({ page: location.href }, "", `/${baseUrl}${location.search}`);
  }
  $(':root').css('--paginatore_horeca', 0);
  renderedData=Object. assign({},data)  ;
  renderedData.refresh=true;

    /*try{
          /!* Gestione Campi SEO *!/
            data.content.seo_title = "RDS Bar Of The Week, gioca in diretta con il tuo bar";
            // cambio il tag 'meta name='description''
            data.content.seo_description='Partecipa al grande torneo a premi tra bar di tutta Italia. Vai in diretta TV. In palio fantastici premi.';

            $(document).attr("title", data.content.seo_title);
            $('meta[name=description]').attr('content',data.content.seo_description);
            /!*$("meta[name=description]").remove();
            $("head").append( "<meta name='description' content=''+data.content.seo_description+''>");*!/

    }catch(e){
            $(document).attr("title", "RDS Bar Of The Week, gioca in diretta con il tuo bar");
        }*/

  const dropzoneOptionsImg = {
    maxFilesize: 10,
    url: "/file/post",
    acceptedFiles: 'image/*',
    autoProcessQueue: false,
    paramName: "fileImg",
    dictDefaultMessage: "Trascina o carica la tua immagine",
    dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    dictInvalidFileType: "You can't upload files of this type.",
    dictResponseError: "Server responded with {{statusCode}} code.",
    dictCancelUpload: "Cancel upload",
    dictUploadCanceled: "Upload canceled.",
    dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    dictRemoveFile: "Remove file",
    maxFiles: 1,
    init: function () {
      const vm = this;
      vm.on("addedfile", file => {
        objectFile.image=  file;
        formData.append('imageType',file.type.split('/')[1]);
        $("#" + vm.element.id + "_check").val(1);
      });
      vm.on("removedfile", function (file) {
        formData.delete('imageType');
        $("#" + vm.element.id + "_check").val(0);
      });
      // vm.on("maxfilesexceeded", function (file) {
      //   this.removeAllFiles();
      //   this.addFile(file);
      // });
      vm.on("error", function (file, message) {
        $("#" + vm.element.id + "_check").val(0);
      });
    },
  };

  const dropzoneOptionsVideo = {
    url: "/file/post",
    autoProcessQueue: false,
    paramName: "fileVideo",
    addRemoveLinks: true,
    uploadMultiple: false,
    acceptedFiles:'video/mp4',
    dictDefaultMessage: "Trascina o carica il tuo video",
    dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    dictInvalidFileType: "You can't upload files of this type.",
    dictResponseError: "Server responded with {{statusCode}} code.",
    dictCancelUpload: "Cancel upload",
    dictUploadCanceled: "Upload canceled.",
    dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    dictRemoveFile: "Rimuovi file",
    maxFiles: 1,
    init: function () {
      const vm = this;
      vm.on("addedfile", file => {
        objectFile.video = file;
        formData.append('videoType',file.type.split('/')[1]);
        $("#" + vm.element.id + "_check").val(1);
      });
      vm.on("removedfile", function (file) {
        // formData.delete('videoType');
        $("#" + vm.element.id + "_check").val(0);
      });
      // vm.on("maxfilesexceeded", function (file) {
      //   this.removeAllFiles();
      //   this.addFile(file);
      // });
      vm.on("error", function (file, message) {
        $("#" + vm.element.id + "_check").val(0);
      });
    }
  };

  Dropzone.autoDiscover = false;
  $('div#dropzone-immagine1').addClass('dropzone');
  $('div#dropzone-video').addClass('dropzone');
  dropzone = new Dropzone("div#dropzone-immagine1", dropzoneOptionsImg);
  dropzoneVideo = new Dropzone("div#dropzone-video", dropzoneOptionsVideo);



  $(".step_scherzo_button").on({
    click: function () {
      var num_page = getComputedStyle(document.documentElement).getPropertyValue('--paginatore_horeca');
      if (num_page == "0") {
        checkLoggedFirstBlock(num_page);
      } else if (num_page == "1") {
        window.history.pushState({ page: location.href }, "", `/${baseUrl}/second_step${location.search}`);
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkSecondBlock(num_page);
      } else if (num_page == "2") {

        window.history.pushState({ page: location.href }, "", `/${baseUrl}/third_step${location.search}`);
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkThirdBlock(num_page);
      } else if (num_page == "3") {

        window.history.pushState({ page: location.href }, "", `/${baseUrl}/fourth_step${location.search}`);
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkFourthBlock();
      }
      $("html, body").animate({ scrollTop: 0 }, 500);
    }
  });

  function checkLoggedFirstBlock(num_page) {
    if (user.checkUser()) {
      window.history.pushState({ page: location.href }, "", `/${baseUrl}/first_step${location.search}`);
      eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
      checkFirstBlock(num_page);
      $("h1").show();
    } else {
      popupNotLogged(num_page);
    }
  }

  function popupNotLogged(num_page){
    if(!$(".popup-messaggio-summerfestival").length){
      const newPopup = $(".popup-messaggio-main").clone( true )
      newPopup.addClass('popup-messaggio-summerfestival').removeClass('popup-messaggio-main');
      $('body').append(newPopup)
    }
    $('.popup-messaggio-summerfestival #messaggio_descrizione_popup').text(`Hai già un'utenza RDS?`);
    $('.popup-messaggio-summerfestival .img-warning img').attr("src","https://media.rds.it/web2/assets/images/generic_message.png");
    $('.popup-messaggio-summerfestival .x-delete.popup-conferma-close').on('click', ()=>{
      $(".popup-messaggio-summerfestival").hide();
    });
    $(".popup-messaggio-summerfestival").show();
    $('.popup-messaggio-summerfestival #btnNo').attr('id','sfbtnNo')
    $('.popup-messaggio-summerfestival #btnYes').attr('id','sfbtnYes')
    $('.popup-messaggio-summerfestival #sfbtnNo').text('ACCEDI');
    $('.popup-messaggio-summerfestival #sfbtnYes').text('REGISTRATI');
    $('.popup-messaggio-summerfestival #sfbtnNo').unbind();
    $('.popup-messaggio-summerfestival #sfbtnYes').unbind();
    $('.popup-messaggio-summerfestival #sfbtnYes').click(()=>{
      window.history.pushState({ page: location.href }, "", `/${baseUrl}/first_step${location.search}`);
      eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
      checkFirstBlock(num_page);
      $(".popup-messaggio-summerfestival").hide()
      $("h1").show();
    });
    $('.popup-messaggio-summerfestival #sfbtnNo').click(()=>{
      // popupNotLogged();
      $(".popup-messaggio-summerfestival").hide()
      user.openPopupLoginAndCallback(()=>{
        window.history.pushState({ page: location.href }, "", `/${baseUrl}/first_step${location.search}`);
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkFirstBlock(num_page);
        $("h1").show();
      })
    });
  }


  function checkMailAlreadyUsed(mailToCheck, fieldName)  {
    return new Promise((resolve, reject)=>{
      if($("#email_giocatore_input").val()==$("#email_input").val())
      {
        $("#email_giocatore_input").parents(".fieldset-gray").addClass("fieldset-error");
        $('#error-message-email_giocatore_input').text("La mail del sostituto non può essere uguale a quella del proprietario");
        resolve(true);
        return
      }
      else
      {
        $("#email_giocatore_input").parents(".fieldset-gray").removeClass("fieldset-error");
        $('#error-message-email_giocatore_input').text("");
      }

      let formMail=new FormData();
      let edizioneYear = new Date().getFullYear().toString();
      formMail.append('mail', mailToCheck);
      formMail.append('userCheck', user.checkUser());
      formMail.append('edizione',  edizioneYear )
      API.postFormData("site/checkMailAlreadyUsedSummerFestival", formMail, function (resp) {
        if (resp.conteggio[0]['conteggio'] >0) {
          $("#" + fieldName).parents(".fieldset-gray").addClass("fieldset-error");
          if(resp.check=='RDS'){
            $('#error-message-'+ fieldName).text("La mail risulta già registrata. Fai login per continuare.");
          }else{
            $('#error-message-'+ fieldName).text("Mail non utilizzabile, usane un'altra");
          }

          resolve(true);
          return;
        } else {
          //$("#" + fieldName).parents(".fieldset-gray").removeClass("fieldset-error");
          $('#error-message-'+ fieldName).text("");
          resolve(false);
          return;
        }
      }, function () {
        reject();
      });
    });
  }

  function checkCFlreadyUsed(CFToCheck, fieldName)  {
    return new Promise((resolve, reject)=>{
      $("#cf_input").parents(".fieldset-gray").removeClass("fieldset-error");
      $('error-message-cf_input').text("");

      let formMail=new FormData();
      let edizioneYear = new Date().getFullYear().toString();
      formMail.append('cf', CFToCheck);
      formMail.append('userCheck', user.checkUser());
      formMail.append('edizione',  edizioneYear )
      API.postFormData("site/checkCFAlreadyUsedSummerFestival", formMail, function (resp) {
        if (resp.conteggio[0]['conteggio'] >0) {
          $("#" + fieldName).parents(".fieldset-gray").addClass("fieldset-error");

          $('#error-message-'+ fieldName).text("Il codice fiscale risulta già registrato.");

          resolve(true);
          return;
        } else {
          //$("#" + fieldName).parents(".fieldset-gray").removeClass("fieldset-error");
          $('#error-message-'+ fieldName).text("");
          resolve(false);
          return ;
        }
      }, function () {
        reject();
      });
    });
  }


  function checkPassword(){
    const password=$('#password_input').val();
    if (password.length < 10) {
      $('#error-message-password_input').text("Campo password non valido; la password deve essere lunga almeno 10 caratteri");
      return false;
    }
    $('#error-message-password_input').text("");
    return true;
  }

  function fillUserField(u) {
    $('#nome_input').val(u.nome);
    $('#cognome_input').val(u.cognome);
    $('#email_input').val(u.email);
    $('#data_nascita_input').val(u.nascita);
    $('#sesso_input').val(u.genere);
    $('#nome_scherzo').text(u.genere);
    $('#telefono_input').val(u.telefono);
    $('#nome_tipologia').val(u.tipologia);
    $('#tipologia_input').val(u.tipologia);
  }


  function checkCap(cap) {
    if (!isNaN(cap) && cap.length == 5)
      return true;
    return false;
  }



  function checkFirstBlock(num_page) {
    let in_error = false;
    if (!in_error) {
      $(".counter_step").removeClass("selected");
      num_page = parseInt(num_page) + 1;
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());
      const _user = user.getLocalUser();
      if (_user) {
        fillUserField(_user);
        $('#blocco_dati_container #password_input').removeClass('obbligatorio_summerfestival');
        $('#blocco_dati_container #password_input_container').hide();
        $('#termini_e_condizioni').hide();
        $('#email_input').attr('disabled', true);
      }else{
        const primoConsenso=$('#form_summerfestival2023-widget_consensi_sf');
        const consensoTermini=`
          <div class="fieldset-container">
            <div class="sofia_font font_12 flex align_center">
                <span class="font_16 opacity_8">Accetto <a href="https://rds.it/termini-e-condizioni" target="_blank">Termini e Condizioni RDS.it</a></span>
                <label class="container_checkbox flex">
                    <input type="checkbox" id="radio-consensi-10" name="radio-consensi-10" class="consensi-check obbligatorio_check" value="1">
                    <span class="checkmark"></span>
                    <img class="icon-error" id="error_radio-consensi-10" style="visibility:hidden;width: 20px;position:relative;top:-10px;left:0px;display:block;"
                        src="https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg">
                </label>
            </div>
          </div>`
        primoConsenso.before(consensoTermini);
      }
      const address1Field = $('#add_input')[0];
      const address2Field = $('#add_bar_input')[0];
      autocomplete = new google.maps.places.Autocomplete(address1Field, {
        // componentRestrictions: { country: ["us", "ca"] },
        fields: ["address_components"],
        types: ["address"],
      });
      autocomplete1 = new google.maps.places.Autocomplete(address2Field, {
        // componentRestrictions: { country: ["us", "ca"] },
        fields: ["address_components"],
        types: ["address"],
      });
      // address1Field.focus();
      // autocomplete.addListener("place_changed", fillInAddress("citta_input","cap_input","provincia_input" ));
      google.maps.event.addListener(autocomplete, 'place_changed', function () {
        var place = autocomplete.getPlace();
        fillInAddress("citta_input", "cap_input", "provincia_input", 'civico_input', place, "add_input");
      });
      google.maps.event.addListener(autocomplete1, 'place_changed', function () {
        var place = autocomplete1.getPlace();
        fillInAddress("citta_bar_input", "cap_bar_input", "provincia_bar_input", 'civico_bar_input', place, "add_bar_input");
      });
      /* autocomplete1.addListener("place_changed", fillInAddress("citta_bar_input","cap_bar_input","provincia_bar_input", autocomplete1 ));*/

      // $(".error-messages").html("");
      // $("fieldset").removeClass("fieldset-error");
    }
  }

  function fillInAddress(citta, cap, provincia, civico, place, callInd) {
    /*  debugger
      const place = autocomplete.getPlace();
      if(!place)
        return;*/
    console.log(place);
    if (!place.address_components || place.address_components.map(i => i.types[0]).indexOf('route') == -1) {
      $("#" + callInd).parents(".fieldset-gray").addClass("fieldset-error");
      $('#error-message-indirizzo_input').text('Seleziona un indirizzo valido dal menu a tendina');
      return;
    }
    if (place.address_components.map(i => i.types[0]).indexOf('route') == -1) {
      $("#" + callInd).parents(".fieldset-gray").addClass("fieldset-error");
      $('#error-message-indirizzo_input').text('Inserisci il nome della strada');
      return;
    }

    else {
      $("#" + callInd).parents(".fieldset-gray").removeClass("fieldset-error");
      $('#error-message-indirizzo_input').text('');
    }
    if(callInd=='add_input'){
      address = place.address_components.find(i => i.types[0] == 'route').long_name;
    }
    if(callInd=='add_bar_input'){
      addressBar = place.address_components.find(i => i.types[0] == 'route').long_name;
    }

    let locality;
    try {
      locality = place.address_components.find(i => i.types[0] == 'locality').long_name;
    } catch (error) {
      locality = place.address_components.find(i => i.types[0] == 'administrative_area_level_3').long_name;
    }

    let postcode="";
    try {
          postcode = place.address_components.find(i => i.types[0] == 'postal_code').long_name;
    }
    catch(e){
        console.warn(e);
    }
    let prov='';
    try {
      prov = place.address_components.find(i => i.types[0] == 'administrative_area_level_2').short_name;
    }catch (e) {
      console.warn(e);
    }


    let streetNumber;
    try {
      streetNumber=place.address_components.map(i => i.types[0]).indexOf('street_number').long_name;
      $("#" + civico).val(streetNumber);
    } catch (error) {

    }
    $("#" + citta).val(locality);
    $("#" + cap).val(postcode);
    $("#" + provincia).val(prov);
  }

  function isMaggiorenne(data_nascita) {
    var oggi = new Date();
    var anni = oggi.getFullYear() - data_nascita.getFullYear();
    var m = oggi.getMonth() - data_nascita.getMonth();
    if (m < 0 || (m === 0 && oggi.getDate() < data_nascita.getDate())) {
      anni--;
    }
    if (anni >= 18)
      return true
    return false;
  }

  async function checkSecondBlock(num_page) {

    let in_error = false;

    $("#email_giocatore_input").parents(".fieldset-gray").removeClass("fieldset-error");
    $("#email_input").parents(".fieldset-gray").removeClass("fieldset-error");
    $('#error-message-data_nascita').text("");
    $('#error-message-email_giocatore_input').text("");
    $('#error-message-email_input').text("");

    $(".obbligatorio_summerfestival").each(function (index) {
      if (this.value == "") {
        // $(this).next(".icon-error").show();
        $(this).parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      } else {
        // $(this).next(".icon-error").hide();
        $(this).parents(".fieldset-gray").removeClass("fieldset-error");
      }
    });

    // TO DO - validazione indirizzo
    $('#citta_input').val('Roma');
    if ($('#citta_input').val() == "") {
      $('#error-message-indirizzo_input').text('Seleziona un indirizzo valido dal menu a tendina');
      $("#add_input").parents(".fieldset-gray").addClass("fieldset-error");
      in_error = true;
    } else {
      $("#add_input").parents(".fieldset-gray").removeClass("fieldset-error");
    }


    /*  if (!checkCap($("#cap_input").val())) {
        $("#cap_input").parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      }*/

    if (!isMaggiorenne(new Date($("#data_nascita_input").val()))) {
      $("#data_nascita_input").parents(".fieldset-gray").addClass("fieldset-error");
      $('#error-message-data_nascita').text("Per poter partecipare al casting devi essere maggiorenne.");
      in_error = true;
    } else{
      $("#data_nascita_input").parents(".fieldset-gray").removeClass("fieldset-error");
    }



    if (!validateMail($("#email_input").val()))
    {
        $("#email_input").parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
    } else {
            if (await checkMailAlreadyUsed($("#email_input").val(), 'email_input'))
            {
              in_error = true;
            }
    }
    if(await checkCFlreadyUsed($("#cf_input").val(), 'cf_input')){
      in_error = true;
    }

    if(!user.checkUser() && !checkPassword()){
      in_error = true;
    }

    if ($("#sostituto_input").val() == 1) {
      if (!validateMail($("#email_giocatore_input").val())) {
        $("#email_giocatore_input").parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      } else if (await checkMailAlreadyUsed($("#email_giocatore_input").val(), 'email_giocatore_input'))
        in_error = true;
    }

    if (!in_error) {
      $(".counter_step").removeClass("selected");
      num_page = parseInt(num_page) + 1;
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());
      $("#error_informativa").hide();
      $(".error-messages").html("");
      $("fieldset").removeClass("fieldset-error");
    } else
      return;

  }

  function callGetCodiceFiscale() {
    const nome = jQuery('#nome_input').val().trim();
    const cognome = jQuery('#cognome_input').val().trim();
    const dataNascita = jQuery('#data_nascita_input').val();
    const genere = jQuery('#sesso_input').val();
    const luogoNascita = jQuery('#nascita_input').val();
    const cfInput = jQuery('#cf_input').val();
    const cfCal = getCoficeFiscale(nome, cognome, dataNascita, luogoNascita, genere);
    // const tipologia =  jQuery('#tipologia_input').val();
    jQuery('#cf_input').val(cfCal);
  }

  function validateMail(mail) {
    let validRegex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    if (mail.match(validRegex))
      return 1;
    return 0;
  }

  function checkThirdBlock(num_page) {

    let in_error = false;

    $(".obbligatorio_bar").each(function (index) {
      if (this.value == "") {
        // $(this).next(".icon-error").show();
        $(this).parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      } else {
        // $(this).next(".icon-error").hide();
        $(this).parents(".fieldset-gray").removeClass("fieldset-error");
      }
    });


    $("#dropzone-immagine1").removeClass("fieldset-error");

    if ($("#dropzone-immagine1_check").val() == 0) {
      $("#dropzone-immagine1").addClass("fieldset-error");
      in_error = true;
    }

    $("#dropzone-video").removeClass("fieldset-error");

    if ($("#dropzone-video_check").val() == 0) {
      $("#dropzone-video").addClass("fieldset-error");
      in_error = true;
    }

    $("#nome_casa_disco_input").parents(".fieldset-gray").removeClass("fieldset-error");
    if($("#nome_casa_disco_input").val() == '' && $("#casa_discografica_input").val() == '1'){
      $("#nome_casa_disco_input").parents(".fieldset-gray").addClass("fieldset-error");
      in_error = true;
    }

    // $("#nome_profilo_social_input").parents(".fieldset-gray").removeClass("fieldset-error");
    // if($("#nome_profilo_social_input").val() == '' && $("#profilo_social_input").val() == '1'){
    //   $("#nome_profilo_social_input").parents(".fieldset-gray").addClass("fieldset-error");
    //   in_error = true;
    // }

    if (!in_error) {

      $(".counter_step").removeClass("selected");
      num_page = parseInt(num_page) + 1;
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());
      $("#error_radio-consensi-0").hide();
      $(".error-messages").html("");
      $("fieldset").removeClass("fieldset-error");
    }

  }

  function checkFourthBlock() {
    let in_error = false;
    $(".obbligatorio_check").each(function (index) {
      if (!$(this).is(":checked")) {
        in_error = true;
        $("#error_" + $(this).attr('id')).css("visibility", "");
        $("#error_" + $(this).attr('id')).show();
      } else {
        $("#error_" + $(this).attr('id')).css("visibility", "hidden");
      }
    });

    if (!in_error) {
      Utils.showWaitingLoader();
      inviaCandidatura();
    }
  }

  $(".previous_step").on({
    click: function () {
      $(".counter_step").removeClass("selected");
      var num_page = getComputedStyle(document.documentElement).getPropertyValue('--paginatore_horeca');
      num_page = parseInt(num_page) - 1;
      if (num_page == 0 ){
        $("h1").hide();
      }
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());

    }
  });

  $('.yes-no-choice .choose_sub_categoria').click(function (e) {
    const target=$(e.currentTarget);
    const targetValue=target.attr('data-value');
    if(!targetValue){
      throw new Error('Empty targetValue!');
    }
    const container=target.closest('.yes-no-choice');
    container.find('.choose_sub_categoria').removeClass("selected");
    target.addClass("selected");
    container.find('input').val(targetValue);

  });

  $(".etichetta_SI").click(function () {
    $(".fieldset-dati-nome_casa_disco").addClass('obbligatorio_summerfestival');
    $(".fieldset-dati-nome_casa_disco").show();
  });

  $(".etichetta_NO").click(function (e) {
    $('#nome_casa_disco_input').val('');
    $(".fieldset-dati-nome_casa_disco").removeClass('obbligatorio_summerfestival');
    $(".fieldset-dati-nome_casa_disco").hide();
  });

  $(".social_SI").click(function () {
    $(".fieldset-dati-nome_canale_social").addClass('obbligatorio_summerfestival');
    $(".fieldset-dati-nome_canale_social").show();
  });

  $(".social_NO").click(function () {
    $('#nome_profilo_social_input').val('');
    $(".fieldset-dati-nome_canale_social").removeClass('obbligatorio_summerfestival');
    $(".fieldset-dati-nome_canale_social").hide();
  });

  function updateFieldGiocatore(isGiocatore) {

    if (isGiocatore) {
      $("#sezioneGiocatore").show();
      $("#nome_giocatore_input").addClass("hidden_input obbligatorio_summerfestival");
      $("#cognome_giocatore_input").addClass("hidden_input obbligatorio_summerfestival");
      $("#email_giocatore_input").addClass("hidden_input obbligatorio_summerfestival");
      $("#telefono_giocatore_input").addClass("hidden_input obbligatorio_summerfestival");
    } else {
      $("#sezioneGiocatore").hide();
      $("#nome_giocatore_input").val("").removeClass("obbligatorio_summerfestival");
      $("#cognome_giocatore_input").val("").removeClass("obbligatorio_summerfestival");
      $("#email_giocatore_input").val("").removeClass("obbligatorio_summerfestival");
      $("#telefono_giocatore_input").val("").removeClass("obbligatorio_summerfestival");
    }
  }

  function inviaCandidatura() {
    $('#email_input').attr('disabled', false);
    const data = $("#form_summerfestival").serializeArray();

    for (const item of data) {
      const _user = user.getLocalUser();
      if (_user && item.name=='password_input') {
        continue;
      }
      formData.append(item.name, item.value);
    }
    formData.append('indirizzo', address + ', ' + data.find(i => i.name=='civico_input').value);

    API.postFormData("site/invia_candidatura_summerfestival", formData, async function (resp) {
      if (resp.status == 1) {
        const user_summer_id = resp.user_summer_id;
        console.log('videourl',resp.presignedUrlVideo);
        console.log('imageurl',resp.presignedUrlImage);
        try {
          $('#overlay-wait').append(`<div id="overlay-wait-progress" style="
                                        position: absolute;
                                        opacity: .8;
                                        left: 50%;
                                        top: 48%;
                                        height: 100px;
                                        transform: translate(-50%,-50%);">0%</div>`
          );
          await Promise.all([uploadFile(objectFile.image, resp.presignedUrlImage,'i'), uploadFile(objectFile.video, resp.presignedUrlVideo,'v')]).then(function (value) {
            console.log(value);
          });
          API.postFormData("site/send_email_summer_conferma",formData);
          $('#overlay-wait-progress').remove();
          Utils.hideWaitingLoader();
          landingsummerfestival();
        } catch (e) {
          API.post("site/rollback_user_summer",{user_summer_id: user_summer_id});
          $('#overlay-wait-progress').remove();
          Utils.hideWaitingLoader();
          alert("Errore");
        }
      } else {
        $('#overlay-wait-progress').remove();
        Utils.hideWaitingLoader();
        alert("Qualcosa è andato storto! Riprovare");
      }
    }, function () {

    });
  }

  /**
   *
   * @param fileToSave
   * @param url
   * @returns {Promise<unknown>}
   */
  function uploadFile(fileToSave,url,type) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.overrideMimeType(fileToSave.type);

      xhr.upload.onprogress = function (evt) {
        if (evt.lengthComputable) {
          console.log(evt);
          if (!!evt.loaded && !!evt.total) {
            let percentage = ((evt.loaded / evt.total) * 100);
            if(type === 'v'){
              perc.video = percentage;
            }else{
              perc.image= percentage;
            }
            updateGlobalPerc();
            console.log('perc_single_file',percentage);
          }
        }
      }
      xhr.onreadystatechange = function () {
        console.log('stato xhr',xhr.readyState, xhr.status);
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve(null);
        } else if (xhr.status !== 200) {
          reject(null);
        }
      }
      xhr.send(fileToSave);
    });
  }

  function updateGlobalPerc(){
    perc.tot = (perc.video+perc.image)/2;
    $('#overlay-wait-progress').text(Math.round(perc.tot)+'%')
  }

  function landingsummerfestival() {
    $(':root').css('--paginatore_horeca', 4);
    window.history.pushState({ page: location.href }, "", `/${baseUrl}/grazie${location.search}`);
    eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
  }

  window.landingsummerfestival = landingsummerfestival;

  /*
  Select Tipologia
   */

  $(".fake-options>div").on({
    click: function () {
      const fakeSelect=$(this).closest('.fake-select');
      fakeSelect.find('.fake-options>div').removeClass("scherzo_selected");
      $(this).addClass("scherzo_selected");
      fakeSelect.find('.fake-select-open').trigger("click");
      fakeSelect.find('input').val($(this).text());
      fakeSelect.find('.fake-select-open span').text($(this).text());
    }
  });

  $(".fake-select-open").on({
    click: function (e) {
      const fakeSelect=$(this).closest('.fake-select');
      // $(fakeSelect).find('.fake-options').slideToggle();
      $(fakeSelect).find('.fake-select-icon').toggleClass('open');
      $(fakeSelect).toggleClass('open');
    }
  });

  $("#cf_input").on('click focus', function () {
    callGetCodiceFiscale();
  });


  //// Ensuring that only Google Maps adresses are inputted
  function selectFirstAddress(input) {
    google.maps.event.trigger(input, 'keydown', { keyCode: 40 });
    google.maps.event.trigger(input, 'keydown', { keyCode: 13 });
  }

  // Select first address on focusout
  $('input.autocomplete-map-summerfestival').on('focusout', function () {
    selectFirstAddress(this);
  });

  // Select first address on enter in input
  $('input.autocomplete-map-summerfestival').on('keydown', function (e) {
    if (e.keyCode == 13) {
      selectFirstAddress(this);
    }
  });
  // Select first address on enter in input
  $('#descrizione_container #descrizione_input').on('keyup', function (e) {
    const counterDiv=$('.chars-counter span');
    const remainingChars=500-$('#descrizione_container #descrizione_input').val().length;
    counterDiv.text(remainingChars);
  });


  //Input on change toggle error style
  $("input.obbligatorio_summerfestival").change(function (index) {
    let is_error = false;
    if($(this).attr('id') == "data_nascita_input"){
      if (!isMaggiorenne(new Date($("#data_nascita_input").val()))) {
        $("#data_nascita_input").parents(".fieldset-gray").addClass("fieldset-error");
        $('#error-message-data_nascita').text("Per poter partecipare al casting devi essere maggiorenne.");
        is_error = true;
      } else{
        $('#error-message-data_nascita').text("");
      }
    }
    if (this.value == "") {
      $(this).parents(".fieldset-gray").addClass("fieldset-error");
      //fieldset-civico
      if($(this).attr('id') == "add_input"){
        $('#error-message-indirizzo_input').text('Seleziona un indirizzo valido dal menu a tendina');
      }
      is_error = true;
    }
    if(!is_error) {
      $(this).parents(".fieldset-gray").removeClass("fieldset-error");
    }
  });

});

